import React, {ChangeEventHandler, FC, useEffect, useState} from 'react'
import {
  getAuthRequirementCurrencyOptionsAsync,
  getAuthRequirementSelectOptionsAsync,
} from 'src/redux/actions/platformActions'
import {useAppDispatch} from 'src/redux/storeHooks'

interface InputProps {
  id: number
  name: string
  data: any
  display_name: string
  input_type?: string
  inputValue: string
  onDataChange: (ev: React.ChangeEvent<HTMLSelectElement>) => void
  
}

const AuthRequirementSelectInput: FC<InputProps> = ({
  display_name,
  id,
  inputValue,
  data,
  name,
  onDataChange,
  input_type,
  
}) => {

  const [options, setOptions] = useState<{label: string; value: string}[]>([])
  const dispatch = useAppDispatch()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const platformName = (data?.name ?? '').toUpperCase()
    const normalizedName = (name ?? '').toLowerCase()
    const normalizedDisplayName = (display_name ?? '').toLowerCase()
    const isCurrencyField =
      normalizedName.includes('currency') || normalizedDisplayName.includes('currency')

    if (id) {
      setLoading(true)
      const shouldFetchCurrencyOptions =
        isCurrencyField || ['LIGHTSPEED', 'ALLEGRO', 'FARFETCH'].includes(platformName)
      const dispatchAction = shouldFetchCurrencyOptions
        ? dispatch(getAuthRequirementCurrencyOptionsAsync())
        : dispatch(getAuthRequirementSelectOptionsAsync({auth_field_id: id}))
      dispatchAction
        .then((res) => {
          if (res.payload?.results) {
            let customizedOptions
            if (['ZALORA', 'NOON', 'CDON', 'KAUFLAND'].includes(platformName)) {
              customizedOptions = res.payload?.results?.map((it) => ({
                label: it?.display_name,
                value: it?.api_id,
              }))
            } else if (shouldFetchCurrencyOptions) {
              customizedOptions = res.payload?.results
                ?.map((it) => {
                  const label =
                    it?.api_name ||
                    it?.display_name ||
                    it?.currency ||
                    it?.currency_iso ||
                    it?.name ||
                    it?.api_id
                  const value = it?.api_id || it?.id || it?.currency_iso || it?.currency || it?.name
                  if (!label || !value) {
                    return null
                  }
                  return {label, value}
                })
                ?.filter((option): option is {label: string; value: string} => Boolean(option))
            } else {
              customizedOptions = res.payload?.results?.map((it) => ({
                label: it?.display_name,
                value: it?.id,
              }))
            }
            if (customizedOptions) {
              setOptions(customizedOptions)
            } else {
              setOptions([])
            }
          }
          setLoading(false)
        })
        .catch((error) => {
          console.error('Error fetching auth requirement select options:', error)
          setLoading(false)
        })
    }
  }, [id])
  
  return (
    <div className='row'>
      <div className='col-md-3 col-6' >
        <label className='form-label'>{display_name}</label>
      </div>
      <div className='col-sm-6 col-12' >
        <select
          value={inputValue}
          onChange={onDataChange}
          className='form-control form-control-solid'
          disabled={loading}
        >
          <option value=''>{display_name + `${loading? ' ...': ''}` } </option>
          {options.length &&
            options.map((option) => {
              return <option value={option.value}>{option.label}</option>
            })}
        </select>
      </div>
    </div>
  )
}

export default AuthRequirementSelectInput
